var ctrlopt = ctrlopt,
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;

  /* Concrete View */
  apptBook.ServicesSelectSection = function (container) {
    apptBook.ServicesSelectSection.superclass.constructor.call(this);
    this.id = 'services';
    this.container = container;
    (this.apptMenu = container.find('.appt-book-page-header-menu')),
      (this.servApplications = container.find('.services-applications'));
    this.servContainer = this.servApplications.find('.services-container');
    this.separateSections = this.servContainer.data('separate-sections') || 0;
    this.sectionDisplay = this.servContainer.data('section-display') || '';
    this.servContainerTemplates = this.servApplications.find('.services-container-templates');
    this.servLessonContainer = container.find('.services-lesson');
    this.servLessonContent = this.servLessonContainer.find('.services-lesson-content');
    this.servLessonContentTemplates = this.servLessonContainer.find('.services-lesson-content-templates');
    this.servicesLesson = this.servLessonContainer.find('.service').css('display', 'none').detach();
    this.services = this.servContainer.find('.service').css('display', 'none').detach();
    apptBook.serviceContent = this.services; // Needed in case the user skips step 2 via edit process
    this.isLesson = 0;
    this.bookBar = this.container.find('.book-now-bar');
    this.bookBarTop = this.container.find('.book-now-bar.top');
    this.totTime = this.bookBar.find('.minutes');
    this.totPrice = this.bookBar.find('.price');
    this.bookBtn = this.bookBar.find('.button');
    this.submitBtn = this.container.find('.submit-services');
    this.legalCopy = this.container.find('.services-legal-copy');
    this.totPriceSelected = this.bookBar.find('.selection-price');
    this.totalPriceSelectedContainer = this.bookBar.find('.selection-price');
    this.totalTimeSelectedDisplay = this.container.find('.js-total_selected_service_time');
    this.totalPriceSelectedDisplay = this.container.find('.js-total_selected_service_price');
    this.initialised = false;
    this.minLabel = container.attr('data-minutes-label');
    this.currSymbol = container.attr('data-currency-symbol');
    this.maxSelectionsTime = parseInt(container.attr('data-max-select'));
    this.msOverlay = container.find('.appt-book-services-overlay').remove();
    this.selErrOverlay = container.find('.appt-book-services-unavailabe-overlay').remove();
    this.redOverlay = container.find('.appt-book-redeemable-services-overlay').remove();
    this.jqBod = $('body');
    this.win = $(window);
    this.boundRun = this.runBuild.bind(this);
    this.totalTime = 0;
    this.totalTimeWithPadding = 0;
    this.totalTimeTxt = 0;
    this.timeSlotInterval = 1;
    this.optionTemp = $('.inline-template[path="/apptBooking/services/service_option"]').html();

    if (
      this.maxSelectionsTime === null ||
      typeof this.maxSelectionsTime === 'undefined' ||
      isNaN(this.maxSelectionsTime)
    ) {
      this.maxSelectionsTime = 120;
    }
  };

  ctrlopt.extend(apptBook.ServicesSelectSection, apptBook.AbstractSection);

  apptBook.ServicesSelectSection.prototype.buildServices = function () {
    if (!this.buildParams || (!this.buildParams.counterId && !this.buildParams.storeId)) {
      return;
    }

    var config = Drupal.settings.appointment_booking_main_collection;
    var serviceSelections,
      cServices,
      serviceMap = {},
      myServices = $(),
      myLessonServices = $(),
      me = this;

    me.totalTime = 0;
    me.totalTimeWithPadding = 0;
    me.totalTimeTxt = 0;

    // Top Book Bar Control Position
    var apptHMenu = me.jqBod.find('.appt-book-page-header'),
      $siteNav = $('.site-header'),
      apptNav = apptHMenu.find('.appointment-nav'),
      bookBarTopInner = me.bookBarTop.find('.book-now-bar-inner'),
      apptNavHeight = $siteNav.height(),
      apptNavPos = parseInt($siteNav.css('top'));

    is_ipad = navigator.userAgent.match(/iPad/i) != null;

    // if (apptBook.isMobile() && !is_ipad) {
    // }

    bookBarTopInner.css('top', apptNavPos + apptNavHeight + 'px');
    $(window).on('siteBanner.close', function () {
      if (bookBarTopInner.length > 0) {
        apptNavHeight = $siteNav.height();
        apptNavPos = parseInt($siteNav.css('top'));
        bookBarTopInner.css('top', apptNavPos + apptNavHeight + 'px');
      }
    });

    if (this.servLessonContainer && this.servLessonContainer[0]) {
      (servLessonContainer = this.servLessonContainer.clone()),
        (servLessonContentTemplates = servLessonContainer.find('.services-lesson-content-templates'));
    }

    this.counterId = this.buildParams.counterId;
    this.storeId = this.buildParams.storeId;
    this.serviceSelIds = this.buildParams.serviceIds;
    this.maxApptServices = this.buildParams.maxApptServices;
    this.maxSelectionsTime =
      this.buildParams.maxApptDuration >= 0 ? parseInt(this.buildParams.maxApptDuration) : this.maxSelectionsTime;
    this.slotInterval =
      typeof this.buildParams.timeSlotInterval !== 'undefined'
        ? parseInt(this.buildParams.timeSlotInterval)
        : this.slotInterval;
    this.maxSelectionMessage = me.jqBod.find('.appt-book-page-header .max_duration_message');
    this.unlimitedServicesMessage = me.jqBod.find('.section-sub-unlimited_services');
    this.selectOptions = [1]; // BOOK FOR FRIEND this.buildParams.bookForFriends;
    this.apptBookingTranslations = site && site.translations ? site.translations.apptBooking : {};
    // TO BE REMOVED
    this.apptBookingTranslations = {};
    this.apptBookingTranslations.service_menu_0 = 'SELECT';
    this.apptBookingTranslations.service_menu_1 = 'Book For Yourself';

    if (this.maxSelectionsTime <= 0 && this.maxSelectionMessage.length > 0) {
      if (this.unlimitedServicesMessage.length > 0) {
        this.maxSelectionMessage.html(this.unlimitedServicesMessage.html());
      }
    } else {
      this.maxSelectionMessage.find('span.max_duration').html(this.maxSelectionsTime);
    }

    for (var i = 0, len = this.servicesData.length; i < len; i += 1) {
      var s = this.servicesData[i];

      serviceMap[s.id] = s;
    }

    cServices = this.model.getCounterServices(this.buildParams.counterId);
    if (this.storeId) {
      this.counterId = this.model.getCounterIdFromStoreId(this.storeId);
      cServices = this.model.getCounterServices(this.counterId);
    } else {
      cServices = this.model.getCounterServices(this.buildParams.counterId);
    }

    if (cServices) {
      this.services.each(function () {
        var sdata,
          serv,
          $this = $(this),
          onlineContentId = $this.attr('data-content-id'),
          minLabel = $this.attr('data-minutes-label'),
          currencySymbol = $this.attr('data-currency-symbol');

        policyGroup = $this.attr('data-policy-group') || '*';
        serviceDescription = $this.find('.js-service-message');
        // adding service description to model data for future steps
        var matchedService = me.servicesData.filter(function (service) {
          return service.online_content_id == onlineContentId;
        })[0];

        if (typeof matchedService !== 'undefined') {
          matchedService.description = serviceDescription.html();
        }

        buildServiceMenu($this, me.selectOptions);

        if (checkService(onlineContentId)) {
          sdata = me.model.getService(onlineContentId);
          if (sdata) {
            serv = $this.clone();
            serv
              .attr('data-duration', sdata.total_duration)
              .find('.selection-time')
              .text(sdata.total_duration + ' ' + minLabel);
            if (sdata.price > 0) {
              sdata.price = sdata.price;
            } else {
              sdata.price = 0;
            }

            if (config.display_sessions_price && parseInt(sdata.price) > 0) {
              title_text = serv.find('.js-service-title');
              $.each(title_text, function (key, value) {
                ini_text = $(this).text();
                $(this).text(ini_text + ' (' + me.currSymbol + parseInt(sdata.price) + ')' + policyGroup);
              });
            }

            // Check selection price to see if alternate text is available.
            var $selectPriceNode = serv.attr('data-price', sdata.price).find('.selection-price');
            var selectionPrice = currencySymbol + parseInt(sdata.price) + policyGroup;
            var selectionPriceAltCopy = $selectPriceNode.data('price-override-text');
            var priceText = selectionPriceAltCopy ? selectionPriceAltCopy : selectionPrice;

            $selectPriceNode.text(priceText);

            serv.attr('data-service-id', sdata.id);
            serv.attr('data-total-duration', sdata.total_duration);
            serv.attr('data-total-duration-with-padding', sdata.total_duration_with_padding);

            serv.find('.selection-selector').click(function (e) {
              var sText,
                stat,
                $this = $(this),
                icon = $this.find('.icon').remove(),
                par = $this.parents('.service'),
                dur = par.attr('data-total-duration'),
                pri = par.attr('data-price'),
                btnLabel = $this.attr('aria-label');

              if ($this.hasClass('selected')) {
                sText = $this.attr('data-select-text');
                stat = 'not-selected';
                $this.removeClass('selected');
                par.removeClass('selected');
                $(this).attr('aria-label', btnLabel.replace($this.attr('data-selected-text'), sText));
              } else {
                sText = $this.attr('data-selected-text');
                stat = 'selected';
                $this.removeClass('not-selected');
                par.removeClass('not-selected');
                $(this).attr('aria-label', btnLabel.replace($this.attr('data-select-text'), sText));
              }

              $this.addClass(stat).prepend(icon);
              $this.find('.js-selection-text').html(sText);
              par.attr('data-status', stat).addClass(stat);
              validateSelection(par);
              $this.focus();
            });
            serv.find('.js-selector').keydown(function (e) {
              if (site.getKeycode(e) === 13) {
                $(this).trigger('click');
              }
            });

            if (me.serviceSelIds) {
              if (me.serviceSelIds.indexOf(parseInt(sdata.id)) > -1) {
                serv.find('.selection-selector').trigger('click');
              }
            }

            // serv.find('.js-service-selector').change(function (e) {
            //   svcSelectChgHandler(this);
            // });
            //
            //
            // serv.find('.js-deselect-service').click(function(e) {
            //   var $service = $(this).parents('.service');
            //   if ($service.length > 0) {
            //     var $srvSelect = $service.find('.js-service-selector');
            //     var $origMenu = $service.find('select.service-select');
            //     $srvSelect.val('0');
            //     svcSelectChgHandler($srvSelect);
            //
            //     $origMenu.removeClass('select-box--replaced');
            //     $origMenu.removeClass('js-select-box-replaced');
            //     $service.find('div.service-select').remove();
            //   }
            //   $(document).trigger('selectBox.refresh');
            // });
          }

          myServices = myServices.add(serv);
        }
      });

      var svcSelectChgHandler = function (selMenu) {
        var $this = $(selMenu);

        (icon = $this.find('.icon').remove()),
          (par = $this.parents('.service')),
          (dur = par.attr('data-total-duration')),
          (pri = par.attr('data-price'));
        if ($this.val() <= 0) {
          sText = $this.attr('data-select-text');
          stat = 'not-selected';
          $this.removeClass('selected');
          par.removeClass('selected');
        } else if (!$this.hasClass('selected')) {
          sText = $this.attr('data-selected-text');
          stat = 'selected';
          $this.removeClass('not-selected');
          par.removeClass('not-selected');
        }
        $this.addClass(stat).html(sText).prepend(icon);
        par.attr('data-status', stat).addClass(stat);
        validateSelection(par);
      };

      if (this.servLessonContainer && this.servLessonContainer[0]) {
        this.servicesLesson.each(function () {
          var sdata,
            serv,
            $this = $(this),
            onlineContentId = $this.attr('data-content-id'),
            minLabel = $this.attr('data-minutes-label'),
            currencySymbol = $this.attr('data-currency-symbol');

          policyGroup = $this.attr('data-policy-group') || '*';

          buildServiceMenu($this, me.selectOptions);

          if (checkService(onlineContentId)) {
            sdata = me.model.getService(onlineContentId);
            me.isLesson = 1;
            if (sdata) {
              serv = $this.clone();
              serv
                .attr('data-duration', sdata.total_duration)
                .find('.selection-time')
                .text(sdata.total_duration + minLabel);
              serv.attr('data-total-duration', sdata.total_duration_with_padding);
              if (sdata.price > 0) {
                sdata.price = sdata.price;
              } else {
                sdata.price = 0;
              }
              serv
                .attr('data-price', sdata.price)
                .find('.selection-price')
                .text(currencySymbol + parseInt(sdata.price));
              serv.attr('data-service-id', sdata.id);

              if (config.display_sessions_price && sdata.price > 0) {
                title_text = serv.find('.js-service-title');
                $.each(title_text, function (key, value) {
                  ini_text = $(this).text();
                  $(this).text(ini_text + ' (' + me.currSymbol + parseInt(sdata.price) + ')' + policyGroup);
                });
              }

              serv.find('.js-service-selector').change(function (e) {
                svcSelectChgHandler(this);
              });
            }

            myLessonServices = myLessonServices.add(serv);
          }
        });
      }

      me.servLessonContainer.detach();
      function getServiceType(thisService) {
        return $(thisService).find('.js-service-type').html().trim().toLowerCase().replace(/\s/g, '_');
      }

      var servicesHash = {};

      for (i = 0; i < myServices.length; ++i) {
        var thisService = myServices[i];
        var serviceType = getServiceType(thisService);

        servicesHash[serviceType] = 1;
      }

      this.servApplications.children('.section-header').show();
      if (me.separateSections && Object.keys(servicesHash).length > 1) {
        // Create the separate sections and their base elements, in the order defined by section-display
        var isCollapsable = me.servApplications.data('accordion-active') || 0;
        var sections = me.sectionDisplay.split(',') || [];

        if (sections.length > 1) {
          this.servApplications.children('.section-header').hide();
        } else {
          this.servApplications.children('.section-header').show();
        }

        for (i = 0; i < sections.length; ++i) {
          var section = sections[i].trim();
          var sectionClass = section.replace(/\s/g, '_').toLowerCase();
          var sectionElement = document.createElement('div');

          $(sectionElement)
            .addClass('lesson-section-' + sectionClass)
            .addClass('lesson-section-block');
          var sectionHeader = document.createElement('h2');

          $(sectionHeader).addClass('lesson-section-header');
          var sectionContent = document.createElement('div');

          $(sectionContent).addClass('section-content');
          $(sectionHeader).html(
            "<div class='section-header' data-section='" + section + "'><p>" + section + '</p></div>'
          );

          if (isCollapsable) {
            $(sectionElement)
              .addClass('lesson-section-' + sectionClass)
              .addClass('js-accordion-container');
            $(sectionHeader).addClass('accordion-header-aplication iconCaretDown');
            $(sectionHeader).append("<hr class='accordion-hr'>");
            $(sectionContent).addClass('accordion-container-services hideAccordionContentAplication');
          }

          sectionElement.appendChild(sectionHeader);
          sectionElement.appendChild(sectionContent);
          this.servContainerTemplates.append(sectionElement);
        }

        // Now loop over the actual services and add them to the relevant container
        for (i = 0; i < myServices.length; ++i) {
          var thisService = myServices[i];
          var serviceType = getServiceType(thisService);
          var parentSection = $('.lesson-section-' + serviceType + ' .section-content');

          if (parentSection) {
            parentSection.append(thisService);
          }
        }

        // Finally unhide the sections that have any services, remove any that do not
        var mySections = $('.lesson-section-block');

        for (i = 0; i < mySections.length; ++i) {
          var thisSection = mySections[i];

          if ($(thisSection).find('.section-content').children().length > 0) {
            $(thisSection).show();
          } else {
            $(thisSection).remove();
          }
        }

        if (isCollapsable) {
          var $servContainerParent = this.servContainer.find('.js-accordion-container');

          $servContainerParent.each(function () {
            var $this = $(this);
            var $servContainer = $this.find('.accordion-container-services');

            if ($this.hasClass('accordion-disable')) {
              $servContainer.addClass('showAccordionContent');
            } else {
              $servContainer.addClass('hideAccordionContent');
              if (!apptBook.isMobile()) {
                if ($this.data('accordion-mobile-only') === 1) {
                  $servContainer.removeClass('hideAccordionContent');
                  $servContainer.addClass('showAccordionContent');
                  $this.addClass('accordion-disable');
                  $this.find('.accordion-header-aplication').removeClass('iconCaretDown');
                }
              }
            }
          });
        }
      } else {
        // If the collapsable class is not present on the servContainer then just use the old/default behavior
        this.servContainerTemplates.append(myServices);
      }
      if (this.servLessonContainer && this.servLessonContainer[0] && this.isLesson) {
        servLessonContentTemplates.append(myLessonServices);
        this.servApplications.after(servLessonContainer);
        this.servLessonContainer = this.container.find('.services-lesson');
        this.servLessonContent = this.servLessonContainer.find('.services-lesson-content');
        this.servLessonContentTemplates = this.servLessonContainer.find('.services-lesson-content-templates');
        myLessonServices.css('display', 'block');
        // Resetting the isLesson variable
        this.isLesson = 0;
      }
      myServices.css('display', 'block');

      if (me.serviceSelIds) {
        _.each(me.serviceSelIds, function (svcId) {
          var $selMenu = $('div[data-service-id=' + svcId + ']').find('.js-service-selector');

          if ($selMenu.length > 0) {
            $selMenu.val('1'); // hard-coded to select "book for self"
            svcSelectChgHandler($selMenu);
          }
        });
      }

      if (myServices.length > 0) {
        if (!apptBook.isMobile()) {
          apptBook.equalHeights(myServices);
        }
      } else {
        this.servApplications.hide();
      }

      if (myLessonServices.length > 0) {
        if (!apptBook.isMobile()) {
          apptBook.equalHeights(myLessonServices);
        }
      } else {
        this.servLessonContainer.hide();
      }

      updateBar();

      this.submitHandler = function (e) {
        var serviceNames = serviceSelections
          .map(function (element) {
            return element.serviceName.trim();
          })
          .join('|');

        site?.track?.evtLink && site.track.evtLink({
          event_name: 'appointmentBooking_Service',
          event_category: 'appointment booking',
          event_action: 'services selected',
          event_label: serviceNames
        });

        me.model.update({
          sectionId: 'next',
          params: {
            counterId: me.counterId,
            services: serviceSelections,
            slotInterval: me.slotInterval,
            appointmentDuration: me.totalTime,
            appointmentDurationWithPadding: me.totalTimeWithPadding,
            updateMode: me.updateMode
          }
        });
      };

      this.win.on('resize', this.boundResize);

      if (!me.separateSections) {
        var $servContainerParent = this.servContainer.parent('.js-accordion-container');

        if ($servContainerParent.hasClass('accordion-disable')) {
          this.servContainer.addClass('showAccordionContent');
        } else {
          this.servContainer.addClass('hideAccordionContent');
          if (!apptBook.isMobile()) {
            if ($servContainerParent.data('accordion-mobile-only') === 1) {
              this.servContainer.removeClass('hideAccordionContent');
              this.servContainer.addClass('showAccordionContent');
              $servContainerParent.addClass('accordion-disable');
              $servContainerParent.find('.accordion-header-aplication').removeClass('iconCaretDown');
            }
          }
        }

        var $servLessonContainerParent = this.servLessonContent.parent('.js-accordion-container');

        if ($servLessonContainerParent.hasClass('accordion-disable')) {
          this.servLessonContent.addClass('showAccordionContent');
        } else {
          this.servLessonContent.addClass('hideAccordionContent');
          if (!apptBook.isMobile()) {
            if ($servLessonContainerParent.data('accordion-mobile-only') === 1) {
              this.servLessonContent.removeClass('hideAccordionContent');
              this.servLessonContent.addClass('showAccordionContent');
              $servLessonContainerParent.addClass('accordion-disable');
              $servLessonContainerParent.find('.accordion-header-aplication').removeClass('iconCaretDown');
            }
          }
        }
      }
      $(document).trigger('selectBox.refresh');
      $(document).trigger('collapsibleBlock.refresh');
    }

    function buildServiceMenu($servNode, options) {
      if (!$servNode.length || !options.length) {
        return null;
      }
      var trans = me.apptBookingTranslations;
      var $origServiceMenu = $servNode.find('select.service-select');

      if (!$origServiceMenu) {
        return null;
      }
      $origServiceMenu.removeClass('select-box--replaced');
      $origServiceMenu.removeClass('js-select-box-replaced');
      $servNode.find('div.service-select').remove();
      $origServiceMenu.html('');
      var defaultNode = Mustache.render(me.optionTemp, { text: trans['service_menu_0'] });

      $origServiceMenu.append(defaultNode);

      for (var i = 0; i < options.length; i++) {
        var option = options[i];
        var text = trans['service_menu_' + option];
        var optNode = Mustache.render(me.optionTemp, {
          id: option,
          text: text
        });

        $origServiceMenu.append(optNode);
      }
    }

    function checkService(id) {
      if (cServices) {
        for (var i = 0, len = cServices.length; i < len; i += 1) {
          var sId = cServices[i];

          if (id === serviceMap[sId].online_content_id) {
            return true;
          }
        }
      }

      return false;
    }

    function validateSelection(lastSelection) {
      var selected;

      if (me.separateSections) {
        (selected = me.servContainerTemplates.find('.service.selected')), (serviceSelectionIds = []);
      } else {
        (selected = me.servContainerTemplates.children('.selected')), (serviceSelectionIds = []);
      }
      if (!lastSelection.hasClass('selected')) {
        updateBar(lastSelection);

        return;
      }
      var selectedCounterData = _.find(me.model.countersData, { id: me.counterId }) || me.model.countersData[0];
      var maxSvcs = selectedCounterData['max_appointment_services'];

      if (maxSvcs > 0 && selected.length > maxSvcs) {
        deselectService(lastSelection);
        launchMsOverlay();

        return null;
      }

      selected.each(function (i) {
        var $this = $(this),
          serviceId = parseInt($this.attr('data-service-id'));

        serviceSelectionIds.push(serviceId);
      });
      me.model.getCounter(me.counterId, { service_id: serviceSelectionIds }, function (data) {
        var counterData = data,
          hasTimeSlots = 0,
          calData = counterData.calendars;

        for (var i = 0, len = calData.length; i < len; i += 1) {
          var timeslots = calData[i].timeslots;

          if (timeslots.length) {
            hasTimeSlots = 1;
          }
        }
        if (!hasTimeSlots) {
          launchSelErrOverlay(lastSelection);
        } else if (!calData || !calData.length) {
          deselectService(lastSelection);
          launchMsOverlay();
        } else {
          updateBar(lastSelection);
        }
      });
    }

    function launchSelErrOverlay(lastSelection) {
      me.jqBod.prepend(me.selErrOverlay);
      me.selErrOverlay.show();
      deselectService(lastSelection);
      console.log('launchSelErrOverlay');
      me.selErrOverlay.click(function (e) {
        e.preventDefault();
        me.selErrOverlay.off('click');
        me.selErrOverlay.remove();
      });
    }

    function launchMsOverlay() {
      me.jqBod.prepend(me.msOverlay);
      me.msOverlay.find('span.max_duration').text(me.maxSelectionsTime);
      me.msOverlay.css('display', 'block').click(function (e) {
        e.preventDefault();
        me.msOverlay.remove();
      });
    }

    function deselectService($svcNode) {
      selBtn = $svcNode.find('.selection-selector').removeClass('selected').addClass('not-selected');
      $svcNode.removeClass('selected').attr('data-status', 'not-selected');
      sText = selBtn.attr('data-select-text');
      selBtn.text(sText);
    }

    function updateBar(lastSelection) {
      var lastTotalTime = me.totalTime;
      var totalPrice = 0;
      var sel,
        selBtn,
        sText,
        sTime,
        icon,
        noselected,
        selected,
        curTime = lastSelection
          ? lastSelection.hasClass('selected')
            ? parseInt(lastSelection.attr('data-total-duration'))
            : -parseInt(lastSelection.attr('data-total-duration'))
          : 0,
        curTimeTxt = lastSelection
          ? lastSelection.hasClass('selected')
            ? parseInt(lastSelection.attr('data-duration'))
            : -parseInt(lastSelection.attr('data-duration'))
          : 0;

      if (me.separateSections) {
        noselected = me.servContainerTemplates.find('.service').not('.selected');
        selected = me.servContainerTemplates.find('.service.selected');
      } else {
        noselected = me.servContainerTemplates.children().not('.selected');
        selected = me.servContainerTemplates.children('.selected');
      }
      me.totalTime += curTime;
      me.totalTimeTxt += curTimeTxt;

      // merge selected normal services with special services
      if (me.servLessonContainer && me.servLessonContainer[0]) {
        if (me.separateSections) {
          selectedLesson = me.servLessonContentTemplates.find('.service.selected');
          noselectedLesson = me.servLessonContentTemplates.find('.service').not('.selected');
        } else {
          selectedLesson = me.servLessonContentTemplates.children('.selected');
          noselectedLesson = me.servLessonContentTemplates.children().not('.selected');
        }
        $.merge(selected, selectedLesson);
        $.merge(noselected, noselectedLesson);
      }

      serviceSelections = [];
      if (typeof me.maxApptServices !== 'undefined') {
        if (
          (me.maxSelectionsTime > 0 && me.totalTime > me.maxSelectionsTime) ||
          (me.maxApptServices > 0 && selected.length > me.maxApptServices)
        ) {
          // alert("Whoops, selected too many. Sorry, can't do that.");

          launchMsOverlay();

          if (lastSelection && lastTotalTime <= me.maxSelectionsTime) {
            sel = lastSelection.removeClass('selected').attr('data-status', 'not-selected');
            sel.addClass('not-selected');
            selMenu = sel.find('.js-service-selector');
            selMenu.prop('selectedIndex', 0);
            selMenu.removeClass('selected');
            selMenu.addClass('not-selected');
            me.totalTime -= curTime;
            me.totalTimeTxt -= curTimeTxt;
          } else {
            var lastIndex = selected.length - 1;

            sel = selected.eq(lastIndex).removeClass('selected').attr('data-status', 'not-selected');
            sel.addClass('not-selected');

            sTime = parseInt(sel.attr('data-total-duration'));
            sTimeWithPadding = parseInt(sel.attr('data-total-duration-with-padding'));
            sTimeTxt = parseInt(sel.attr('data-duration'));
            selMenu = sel.find('.js-service-selector');
            selMenu.prop('selectedIndex', 0);
            selMenu.removeClass('selected');
            selMenu.addClass('not-selected');
            me.totalTime -= sTime;
            me.totalTimeWithPadding -= sTimeWithPadding;
            me.totalTimeTxt -= sTimeTxt;
          }
          // Trigger select menu refresh
          $(document).trigger('selectBox.refresh');

          updateBar();

          return;
        }
      }

      me.totalTime = 0;
      me.totalTimeWithPadding = 0;
      me.totalTimeTxt = 0;

      selected.each(function (i) {
        var $this = $(this),
          time = parseInt($this.attr('data-total-duration')),
          timeWithPadding = parseInt($this.attr('data-total-duration-with-padding')),
          timeTxt = parseInt($this.attr('data-duration')),
          price = parseInt($this.attr('data-price')),
          serviceId = parseInt($this.attr('data-service-id')),
          serviceName = $this.find('.js-service-title').first().text(),
          serviceType = $this.find('.js-service-type').text();

        serviceImg = $this.find('.service-content__image').attr('src');

        me.totalTime += time;
        me.totalTimeWithPadding += timeWithPadding;
        me.totalTimeTxt += timeTxt;
        totalPrice += price;

        $this.removeClass('time-out-range');

        serviceSelections.push({
          serviceId: serviceId,
          serviceDuration: timeTxt,
          servicePrice: price,
          serviceName: serviceName,
          serviceType: serviceType,
          serviceImg: serviceImg
        });
      });

      noselected.each(function (i) {
        var $this = $(this),
          time = parseInt($this.attr('data-total-duration'));

        $this.removeClass('time-out-range');

        if (me.maxSelectionsTime > 0 && me.totalTime > 0 && me.totalTime <= me.maxSelectionsTime) {
          if (time > me.maxSelectionsTime - me.totalTime) {
            $this.addClass('time-out-range');
          }
        }
      });

      if (me.totalTime > 0) {
        me.submitBtn.removeClass('disabled');
        me.submitBtn.html(me.submitBtn.data('submit'));
        me.totalTimeSelectedDisplay.html(me.totalTime);
        me.totalPriceSelectedDisplay.html(totalPrice);
        // this gets applied every time a selection is made, so unbind then re-bind
        me.submitBtn.unbind().bind('click', function (e) {
          e.preventDefault();
          me.submitHandler(e);
        });
        me.bookBarTop.addClass('active');
      } else {
        me.submitBtn.addClass('disabled');
        me.submitBtn.html(me.submitBtn.data('restart'));
        me.totalTimeSelectedDisplay.html('0');
        me.totalPriceSelectedDisplay.html('0');
        me.submitBtn.off('click');
        // Disable the submit 'button' if no services/no total time
        me.submitBtn.unbind().bind('click', function (e) {
          e.preventDefault();
        });

        me.bookBarTop.removeClass('active');
      }

      if (totalPrice > 0) {
        me.totalPriceSelectedContainer.show();
      } else {
        me.totalPriceSelectedContainer.hide();
      }

      me.totTime.text(me.totalTimeTxt + me.minLabel);
      me.totPrice.text(me.currSymbol + totalPrice);
    }

    function onResize() {
      myServices.css('height', 'auto');
      if (myServices.length > 1) {
        if (!apptBook.isMobile()) {
          apptBook.equalHeights(myServices);
        }
      }
      myLessonServices.css('height', 'auto');
      if (myLessonServices.length > 1) {
        if (!apptBook.isMobile()) {
          apptBook.equalHeights(myLessonServices);
        }
      }
    }
    this.boundResize = onResize.bind(this);

    this.win.on('resize', _.debounce(this.boundResize));

    // For Chrome and iPad.
    // NOTE: Will remove with better option.
    // setTimeout(function() {
    //   $(window).trigger('resize');
    // }, 250);
  };

  apptBook.ServicesSelectSection.prototype.collapseMenuOverride = function () {
    if (site.client.isMobile && $('.collapsible-block.service').length) {
      $($('.collapsible-block.service')[0]).removeClass('collapsible-block--alt');
    }
    this.overrideMenu = function (e, args) {
      var $blocks = args.blocks;
      var $trigger = args.trigger;
      var $parentBlock = $trigger.closest('.collapsible-block');
      var isActive = $parentBlock.hasClass('collapsible-block--alt');

      $blocks.each(function () {
        $(this).closest('.collapsible-block').addClass('collapsible-block--alt');
      });
      if (!isActive) {
        $parentBlock.removeClass('collapsible-block--alt');
      } else {
        $parentBlock.addClass('collapsible-block--alt');
      }
    };
    $(document).on('collapsibleBlock.trigger', $.proxy(this.overrideMenu, this));
  };

  apptBook.ServicesSelectSection.prototype.runBuild = function () {
    this.config = Drupal.settings.appointment_booking_main_collection;
    var hasVirtual = localStorage.getItem('virtual_oab') || 0;

    if (hasVirtual) {
      $('.appt-book-link', this.container).addClass('hidden');
    }
    this.buildServices();
    this.collapseMenuOverride();
  };

  apptBook.ServicesSelectSection.prototype.onUpdate = function (data) {
    var aPgName = document.title + ' - Services Select';
    var config = Drupal.settings.appointment_booking_main_collection;

    if (this.boundResize) {
      this.win.off('resize', this.boundResize);
    }
    if (data.sectionId === this.id) {
      if (config.display_sessions_price && config.price_legal_copy) {
        this.legalCopy.show().html(config.price_legal_copy);
        this.totalPriceSelectedContainer.show();
      } else {
        this.legalCopy.hide();
        this.totalPriceSelectedContainer.hide();
      }

      this.buildParams = data.params;
      if (data.params.updateMode) {
        this.updateMode = true;
      } else {
        this.updateMode = false;
      }

      this.servicesData = this.model.getServices();
      this.servContainerTemplates.empty();
      if (this.servLessonContainer && this.servLessonContainer[0]) {
        this.servLessonContentTemplates.empty();
      }

      apptBook.sectionManager.on('transition_in_start', this.boundRun);
    } else {
      apptBook.sectionManager.off('transition_in_start', this.boundRun);
    }
  };

  Drupal.behaviors.apptBookServices = {
    attach: function (context) {
      var view = new apptBook.ServicesSelectSection($('#services'));

      view.setModel(apptBook.sectionModel).startObserving();
    }
  };

  $(document).ready(function () {
    var enableBookBar = function () {
      $('.book-now-bar-inner').css('display', 'block');
    };
    var disableBookBar = function () {
      $('.book-now-bar-inner').css('display', 'none');
    };

    $(document).on('click', '.accordion-header-aplication', function () {
      var $accordianContainer = $(this).parent('.js-accordion-container');

      // Handle when accordion is disabled.
      if ($accordianContainer.hasClass('accordion-disable')) {
        return null;
      } else {
        if ($accordianContainer.data('accordion-mobile-only') === 1 && !apptBook.isMobile()) {
          return null;
        }
      }

      var flagAplication = 0;
      var services = $accordianContainer.find('.accordion-container-services');

      if (services.hasClass('hideAccordionContentAplication')) {
        $(this).removeClass('iconCaretDown').addClass('iconCaretUp');
        services.removeClass('hideAccordionContentAplication').addClass('showAccordionContentAplication');
        services.removeClass('hideAccordionContent').addClass('showAccordionContent');
        enableBookBar();
        if (apptBook.isMobile()) {
          $(window).trigger('resize');
        }
        flagAplication = 1;
      }
      if (services.hasClass('showAccordionContentAplication') && flagAplication == 0) {
        $(this).removeClass('iconCaretUp').addClass('iconCaretDown');
        services.removeClass('showAccordionContentAplication').addClass('hideAccordionContentAplication');
        services.removeClass('showAccordionContent').addClass('hideAccordionContent');
      }
    });
  });
})(jQuery);

(function () {
  document.addEventListener('lazybeforeunveil', function (e) {
    var isMobile = site.client.isMobile;
    var bg = e.target.getAttribute('data-bg');

    if (isMobile && typeof e.target.getAttribute('data-bg-mobile') !== 'undefined') {
      bg = e.target.getAttribute('data-bg-mobile');
    }
    if (bg) {
      e.target.style.backgroundImage = 'url(' + bg + ')';
    }
  });
})();
